import React, {useCallback} from 'react';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';
import Heading from 'js/components/Common/Heading/Heading';
import Thumbnail from 'js/components/Common/Thumbnail/Thumbnail';
import Description from 'js/components/Common/Description/Description';
import MediaDuration from 'js/components/Common/MediaDuration/MediaDuration';
import VisibilityViewerIcon from 'js/components/Common/VisibilityViewerIcon/VisibilityViewerIcon';

import Views from '../../components/Views/Views';
import WatchTime from '../../components/WarchTime/WatchTime';
import commonClasses from '../../../SearchResultsItem/SearchResultsItem.module.pcss';
import ProductLabelsList from 'js/components/Common/ProductLabelList/ProductLabelsList';
import Label from 'js/containers/Pages/Search/SearchResults/Entities/components/Label/Label';

export interface Props {
    data: {
        id: number,
        title: string,
        featuredImage: {
            url: string,
            altText: string
        },
        type: 'videos',
        product: string,
        description: string,
        videoDuration: string,
        publishingDate: string,
        watchTime: string,
        views: number,
        link: string
    },
    isPromoted: boolean,
    isAISearch: boolean
}

const Video = ({data, isPromoted, isAISearch}: Props) => {
    const {
        title,
        videoDuration,
        description,
        link,
        watchTime,
        views
    } = data || {};

    const sendMixPanelEvent = useCallback(async () => {
        await MixPanelWrapper.TrackEvent(
            'Open Video page',
            {
                category: 'Search Results',
                value: data?.title,
                searchType: isAISearch ? 'AI' : 'Regular'
            });
    }, [data, isAISearch]);
    return (
        <div className={`${commonClasses.SearchResultItem} ${isPromoted && commonClasses.Promoted}`}>
            <Thumbnail additionalClass={commonClasses.Thumbnail} type={'videos'} alt={data?.title} />
            <span className={commonClasses.SearchResultItemInfo}>
                <div className={commonClasses.SearchResultItemInfoTop}>
                    <div className={commonClasses.TitleWrap}>
                        <a onClick={sendMixPanelEvent} href={link} target={'_blank'} rel={'noopener noreferrer'}>
                            <Heading text={title} type={'h5'}/>
                        </a>
                        <VisibilityViewerIcon
                            id={data?.id}
                        />
                    </div>
                    <Description data={description}/>
                    <ProductLabelsList pageId={data?.id}/>
                </div>
                <div className={commonClasses.Wrap}>
                    <Label type={'videos'}/>
                    <MediaDuration data={videoDuration}/>
                    <WatchTime data={watchTime}/>
                    <Views data={views}/>
                </div>
            </span>
        </div>
    );
};

export default Video;
